import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';

const MODULES: any[] = [FormsModule, ReactiveFormsModule];

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MODULES],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private authService = inject(AuthService);
  private oauthService = inject(OAuthService);
  
  constructor () {
    this.authService.login();
  }
  signIn() {
    this.authService.login();
  }
}
